import { useState, useEffect } from 'react';
import apiClient from '../api/api';

const useSecureImage = (url) => {
    const [imgSrc, setImgSrc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        const fetchImage = async () => {
            if (!url) {
                setLoading(false);
                return;
            }
            try {
                setLoading(true);
                const response = await apiClient.get(url, { responseType: 'blob' });

                if (active) {
                    const objectUrl = URL.createObjectURL(response.data);
                    setImgSrc(objectUrl);
                    setLoading(false);
                }
            } catch (err) {
                console.error("Failed to load secure image:", url, err);
                if (active) {
                    setError(true);
                    setLoading(false);
                }
            }
        };

        fetchImage();
        return () => {
            active = false;
            if (imgSrc) {
                URL.revokeObjectURL(imgSrc);
            }
        };
    }, [url]); 

    return { imgSrc, loading, error };
};

export default useSecureImage;